import { Box, Typography } from "@mui/material";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import Button from "../../UI/Button";
import { useNavigate } from "react-router-dom";

const translationPath = "components.formNotFound.";

export const FormNotFound = memo(() => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const redirectUserHandler = useCallback(() => {
    navigate("/");
  }, [navigate]);

  return (
    <Box
      sx={{
        height: "90%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
      }}
    >
      <img
        src="/form-not-found.png"
        alt="Form not found"
        style={{ height: 250 }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography fontWeight="bold" variant="h5">
          {t(translationPath + "message")}
        </Typography>
        <Typography
          sx={(t) => ({
            color: t.palette.grey[t.palette.mode === "light" ? 600 : 400],
          })}
        >
          {t(translationPath + "subtitle")}
        </Typography>
      </Box>
      <Button variant="contained" onClick={redirectUserHandler}>
        {t(translationPath + "button")}
      </Button>
    </Box>
  );
});
